<template>
  <div class="login" style="height: calc(100vh);width: 100%;">
    <img :src="$store.state.appInfo.background" class="absolute"
         style="z-index: -1;min-width: 440px;min-height:600px;width: calc(100vw);height: calc(100vh);"/>
    <div class="text-center">
      <div class="inline-block" style="margin-top:5%;width: 440px;height: 550px;background-color: rgba(255,255,255,0.9);border-radius: 16px;box-shadow:0px 8px 24px rgba(5,0,85,0.08);">
        <div class="text-center" style="height: 250px;">
          <template v-if="!Tool.isNull($store.state.appInfo)">
            <el-image :src="$store.state.appInfo.logoUrl" style="width: 70px;height: 70px;margin-top: 60px;border-radius: 4px;"></el-image>
            <div style="font-size: 28px;color: #333333;margin-top: 16px;">{{$store.state.appInfo.organizationName}}</div>
          </template>
        </div>
        <div style="padding: 0px 50px;height: 300px;">
          <el-form v-if="form" :model="form" ref="form" label-width="0px" :hide-required-asterisk="true">
            <div>
              <!--            <div v-if="type=='resetPass'">-->
              <!--              <div type="text" class="inline-block pointer" style="margin-bottom: 20px;margin-top:10px;font-size: 20px;color: #606266;">重置密码</div>-->
              <!--            </div>-->
              <!--            <div v-else>-->
              <!--              <div type="text" v-for="(item,i) in tabList" :key="i" @click="type=item.name"-->
              <!--                   class="inline-block pointer" style="margin-bottom: 20px;margin-top:10px;font-size: 20px;margin-right: 20px;" :style="{color:item.name==type?'#409EFF':'#606266'}">-->
              <!--                {{item.label}}-->
              <!--              </div>-->
              <!--            </div>-->
              <el-form-item label="" prop="mobile" label-width="0px" :rules="[$validate.mobile()]">
                <el-input v-model="form.mobile" @input="e=>form.mobile=Tool.checkNumber(e)" :maxlength="11" placeholder="请输入手机号" clearable></el-input>
              </el-form-item>
<!--              <el-form-item label="" prop="passWord" label-width="0px" :rules="[$validate.password(6,12)]">-->
<!--                <el-input v-model="form.passWord" type="password" show-password :maxlength="12" placeholder="请输入密码"></el-input>-->
<!--              </el-form-item>-->
              <el-form-item v-if="['loginByVcode','resetPass'].indexOf(type)>-1" label="" prop="vcode" label-width="0px" :rules="[$validate.vcode(6)]">
                <el-input v-model="form.vcode" @input="e=>form.vcode=Tool.checkNumber(e)" :maxlength="6" placeholder="请输入验证码" @ended="checkInput"></el-input>
                <div class="absolute text-right flex-middle" style="right: 10px;margin-top: -35px;">
                  <div class="inline-block" style="border-left: solid 1px #cccccc;height: 25px;width: 10px;"></div>
                  <el-button v-if="time==-1" style="margin-right: 0px;color: #4E45EE;" type="text" @click.stop="sendVcode">发送验证码</el-button>
                  <el-button v-else-if="time==0" style="margin-right: 0px;color: #4E45EE;" type="text" @click.stop="sendVcode">重新发送</el-button>
                  <span v-else style="margin-right: 0px;color: #606266;">重新发送({{time}}S)</span>
                </div>
              </el-form-item>
              <el-form-item v-if="['resetPass'].indexOf(type)>-1" label="新密码" prop="newPass" :rules="[$validate.password(6,20)]">
                <el-input v-model="form.newPass" type="password" :maxlength="20" placeholder="请输入新密码"></el-input>
              </el-form-item>
              <div class="text-center">
                <div class="inline-block">
                  <DragVerify :width="340" :height="40" progress-bar-bg="#23C266" text-size="20px" background="#E5E5E5" handler-icon="icon icon_arrow-right" success-icon="icon icon_arrow-right"
                              text="请将滑块拖动到右侧" success-text="验证通过" @passcallback="checkInput(true)" color="#ffffff">
                  </DragVerify>
                </div>
              </div>
            </div>
          </el-form>
          <div v-if="type=='resetPass'" class="text-right" style="margin-top: 20px;">
            <el-button type="text" @click="type='loginByPass'"><i class="icon icon_back"></i> 返回登录</el-button>
            <el-button :disabled="disabled" size="medium" type="primary" @click="submit()">重置密码</el-button>
          </div>
          <div v-else class="text-center" style="margin-top: 20px;">
            <el-button :disabled="disabled" size="medium" type="primary" @click="submit()" style="width: 340px;">登录</el-button>
<!--            <el-button type="text" @click="$router.push({path:'/index/changePass'})">忘记密码?</el-button>-->
          </div>
        </div>
      </div>
      <div style="margin-top: 20px;color: #ffffff;">
        <i class="icon icon_phone"></i>
        {{$store.state.appInfo.phone}}
      </div>
    </div>
    <div class="text-center fixed" style="color: #ffffff;font-size: 12px;bottom: 10px;width: 100%;">
      {{$store.state.appInfo.bottomDesc}}
    </div>
  </div>
</template>
<script>
import DragVerify from 'vue-drag-verify'

export default {
  name: 'login',
  components: { DragVerify },
  props: [],
  data () {
    return {
      form: {
        mobile: process.env.NODE_ENV === 'test' ? '13066990026' : (process.env.NODE_ENV === 'development' ? '15666666666' : ''),
        password: '',
        newPass: '',
        vcode: ''
      },
      tabList: [{ name: 'loginByPass', label: '密码登录' }, { name: 'loginByVcode', label: '验证码登录' }],
      type: 'loginByVcode',
      time: -1,
      interval: 0,
      disabled: true,
      call: false
    }
  },
  created () {
    this.$store.commit('setCurrentUserInfo', {})
  },
  async mounted () {
  },
  async beforeDestroy () {
    clearInterval(this.interval)
  },
  computed: {},
  watch: {
    form: {
      handler: function () {
        this.checkInput()
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    checkInput (passOK = false) {
      if (passOK) {
        this.form.passOK = passOK
      }
      if (this.form.passOK && this.type === 'loginByPass' && /^1\d{10}$/.test(this.form.mobile) && /^.{6,12}$/.test(this.form.password)) {
        this.disabled = false
      } else if (this.form.passOK && this.type === 'loginByVcode' && /^1\d{10}$/.test(this.form.mobile) && /^.{6,12}$/.test(this.form.vcode)) {
        this.disabled = false
      } else if (this.form.passOK && this.type === 'resetPass' && /^1\d{10}$/.test(this.form.mobile) && /^.{6,20}$/.test(this.form.vcode) && /^.{6,12}$/.test(this.form.newPass)) {
        this.disabled = false
      } else {
        this.disabled = true
      }
    },
    async submit () {
      let isOK = await this.Tool.checkForm(this.$refs['form'])
      if (isOK) {
        if (this.type === 'loginByPass') {
          let userInfo = await this.$HTTP.ApiUser.loginByPass(this.form.mobile, this.form.password)
          this.afterLogin(userInfo)
        } else if (this.type === 'loginByVcode') {
          // let userInfo = await this.$HTTP.ApiUser.loginByVcode(this.form.mobile, this.form.vcode, this.form.passWord)
          let userInfo = await this.$HTTP.ApiUser.loginByVcode(this.form.mobile, this.form.vcode)
          this.afterLogin(userInfo)
        } else if (this.type === 'resetPass') {
          await this.$HTTP.ApiUser.resetPass(this.form.mobile, this.form.vcode, this.form.newPass)
          this.$message({ type: 'success', message: '重置密码成功，请使用新密码登录' })
          this.type = 'loginByPass'
          this.form.vcode = null
          clearInterval(this.interval)
          this.time = 0
        }
      }
    },
    afterLogin (userInfo) {
      try {
        this.$store.commit('setCurrentUserInfo', userInfo)
        if (!this.Tool.isNull(userInfo.menuList)) {
          let menuRouter = this.$HTTP.ApiMenu.getMenuRouter()
          this.$router.addRoutes(menuRouter)
          for (let i in menuRouter) {
            if (menuRouter[i].isPage) {
              this.$router.push(menuRouter[i].path)
              return true
            }
          }
        } else {
          throw new Error('您的账号没有绑定角色，请联系管理员分配权限')
        }
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async sendVcode () {
      let isOK = await this.Tool.checkForm(this.$refs['form'], ['mobile'])
      if (isOK) {
        let smsType = this.type === 'resetPass' ? '1' : '2'
        let vcode = await this.$HTTP.ApiUser.sendVcode(this.form.mobile, smsType)
        if (vcode && /^\d{6}$/.test(vcode)) {
          this.form.vcode = vcode
          this.$refs['form'].clearValidate()
        }
        this.$message({ type: 'success', message: '发送验证码成功' })
        this.time = 60
        this.interval = setInterval(() => {
          if (this.time > 0) {
            this.time--
          } else {
            clearInterval(this.interval)
          }
        }, 1000)
      }
    }
  }
}
</script>
<style>
  .dv_text {
    font-size: 14px !important;
  }

  .dv_handler {
    margin-top: 2px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
    border-radius: 19px !important;
    width: 60px !important;
    height: 36px !important;
    border: none !important;
  }

  .dv_handler .icon {
    color: #23C266 !important;
  }

  .login .el-button.el-button--primary.is-disabled {
    background-color: rgba(78, 69, 238, 0.3) !important;
    border-color: rgba(78, 69, 238, 0.3) !important;
  }

  .login .el-button.el-button--primary {
    background-color: rgba(78, 69, 238, 1) !important;
    border-color: rgba(78, 69, 238, 1) !important;
  }
</style>
